import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import type { AnalyticsEvent, TrackEventResponse, BatchFlushResponse } from '@naybrs/analytics';

/** HTTP transport for marketing analytics events. */
@Injectable({ providedIn: 'root' })
export class MarketingAnalyticsApiService {
  private readonly apiUrl: string = environment.naybrsAwsApi;

  constructor(private readonly http: HttpClient) {}

  trackEvent(event: AnalyticsEvent): Observable<TrackEventResponse> {
    return this.http.post<TrackEventResponse>(
      `${this.apiUrl}/analytics/track`,
      event,
    );
  }

  batchFlush(events: AnalyticsEvent[]): Observable<BatchFlushResponse> {
    return this.http.post<BatchFlushResponse>(
      `${this.apiUrl}/analytics/batch`,
      { events },
    );
  }

  sendBeacon(events: AnalyticsEvent[]): boolean {
    if (typeof navigator?.sendBeacon !== 'function') {
      return false;
    }
    const payload = JSON.stringify({ events });
    return navigator.sendBeacon(`${this.apiUrl}/analytics/batch`, payload);
  }
}
